module.exports = __webpack_public_path__ + "img/im.70724ac4.svg";